// CAV6 Design Tokens
// Brand color comes dynamically from theme.palette.primary.main

export const CAV6 = {
  // Font
  font: '"Poppins", ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',

  // Max width
  maxWidth: '480px',

  // Timing
  morphMs: 560,
  labelFadeMs: 320,
  sharedAxisMs: 700,
  barMs: 800,

  // Easing
  easeIn: 'cubic-bezier(.55,.02,.84,.21)',
  easeOut: 'cubic-bezier(.16,1,.3,1)',
  sharedAxisEase: 'cubic-bezier(.16,1,.3,1)',
  barEase: 'cubic-bezier(.2,0,.2,1)',

  // Colors (static, non-brand)
  bg: '#fff',
  text: 'rgba(0,0,0,.92)',
  muted: 'rgba(0,0,0,.62)',
  outline: 'rgba(0,0,0,.14)',

  // Safe-area CSS values
  introBottom: 'calc(24px + env(safe-area-inset-bottom))',
  introTop: 'calc(18px + env(safe-area-inset-top))',
  introHeroTop: 'calc(50px + env(safe-area-inset-top))',
  homeTop: 'calc(30px + env(safe-area-inset-top))',
  supportBottom: 'calc(20px + env(safe-area-inset-bottom))',

  // Support pill
  supportPillH: '44px',
  recaptchaGap: '16px',

  // Pill radius
  pillRadius: '999px',
} as const;
